import { render, staticRenderFns } from "./CompanyEditTabAccount.vue?vue&type=template&id=4de3bb3e"
import script from "./CompanyEditTabAccount.vue?vue&type=script&lang=js"
export * from "./CompanyEditTabAccount.vue?vue&type=script&lang=js"
import style0 from "./CompanyEditTabAccount.vue?vue&type=style&index=0&id=4de3bb3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports